import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class OrdersShippingMethodsApiService extends ApiService {
  static endpoint = 'orders/{order_id}/shipping-methods';

  /**
   * @param {String|Number} orderId
   * @param {Number|null} shippingMethodId
   * @return {String}
   * @protected
   */
  static buildOrderShippingMethodUrl(orderId, shippingMethodId = null) {
    return this.buildUrl(shippingMethodId).replace('{order_id}', orderId);
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} shippingMethodId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @public
   */
  static async patch(orderId, shippingMethodId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildOrderShippingMethodUrl(orderId, shippingMethodId), data, {
      ...config,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
